import React, { useEffect, useState } from 'react';
import useAsync from '../hooks/useAsync';
import AdminServices from '../services/AdminServices';
import ReactApexChart from 'react-apexcharts';
import moment from 'moment';
import { SlCalender } from "react-icons/sl";
import { MdOutlinePendingActions } from "react-icons/md";
import { MdIncompleteCircle } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FiUserCheck } from "react-icons/fi";
import { LuUserX } from "react-icons/lu";

function Dashboard() {

  const [selectedTab, setSelectedTab] = useState('today');
  const { data: todayData } = useAsync(AdminServices.dashboardToday);
  const { data: totalData } = useAsync(AdminServices.dashboard);

  const [chartData, setChartData] = useState({
    categories: ['Current Month', 'Previous Month'],
    seriesUser: [],
    seriesBooking: [],
    seriesBookingDaily: [],
    categoriesBookingDaily: [],
    totals: {}
  });


  useEffect(() => {
    if (totalData && totalData.data) {
      const currentMonth = moment().month();
      const previousMonth = currentMonth === 0 ? 11 : currentMonth - 1;
      const currentYear = moment().year();
      const previousYear = currentMonth === 0 ? currentYear - 1 : currentYear;

      const monthsInRange = [];
      const monthNames = [];

      for (let i = 0; i <= currentMonth; i++) {
        monthsInRange.push(i);
        monthNames.push(moment().month(i).format('MMM'));
      }

      const userCounts = new Array(monthsInRange.length).fill(0);
      const bookingCounts = new Array(monthsInRange.length).fill(0);
      const ratingCounts = new Array(5).fill(0);

      let totalUsers = 0;
      let totalBookings = 0;


      totalData?.data?.userCount?.forEach((user) => {
        const month = moment(user.createdAt).month();
        const monthIndex = monthsInRange.indexOf(month);
        if (monthIndex !== -1) {
          userCounts[monthIndex]++;
          totalUsers++;
        }
      });

      totalData?.data?.bookingCount?.forEach((booking) => {
        const month = moment(booking.createdAt).month();
        const monthIndex = monthsInRange.indexOf(month);
        if (monthIndex !== -1) {
          bookingCounts[monthIndex]++;
          totalBookings++;
        }
      });

      let totalRatings = 0;
      totalData?.data?.ratingCount?.forEach((rating) => {
        if (rating._id >= 1 && rating._id <= 5) {
          ratingCounts[5 - rating._id] = rating.count;
          totalRatings += rating.count;
        }
      });


      const daysInCurrentMonth = moment().daysInMonth();
      const daysInPreviousMonth = moment().month(previousMonth).year(previousYear).daysInMonth();
      const maxDays = Math.max(daysInCurrentMonth, daysInPreviousMonth);


      const bookingCountsCurrentMonth = new Array(maxDays).fill(0);
      const bookingCountsPreviousMonth = new Array(maxDays).fill(0);
      const bookingDays = Array.from({ length: maxDays }, (_, i) => (i + 1).toString());

      totalData?.data?.bookingCount?.forEach((booking) => {
        const createdAt = moment(booking.createdAt);
        const bookingMonth = createdAt.month();
        const bookingYear = createdAt.year();
        const day = createdAt.date(); // 1-based day

        if (day <= maxDays) {
          if (bookingMonth === currentMonth && bookingYear === currentYear) {
            bookingCountsCurrentMonth[day - 1]++;
          } else if (bookingMonth === previousMonth && bookingYear === previousYear) {
            bookingCountsPreviousMonth[day - 1]++;
          }
        }
      });

      setChartData({
        categories: monthNames,
        seriesUser: [{ name: 'Customers', data: userCounts }],
        seriesBooking: [{ name: 'Bookings', data: bookingCounts }],
        seriesBookingDaily: [
          {
            name: `Current Month (${moment().format('MMM YYYY')})`,
            data: bookingCountsCurrentMonth
          },
          {
            name: `Previous Month (${moment().month(previousMonth).format('MMM YYYY')})`,
            data: bookingCountsPreviousMonth
          }
        ],
        categoriesBookingDaily: bookingDays,
        totals: {
          users: totalUsers,
          bookings: totalBookings,
          ratings: totalRatings
        }
      });
    }
  }, [totalData]);

  // const chartOptions = (title, total, categories = []) => ({
  //   chart: {
  //     type: "bar",
  //     toolbar: {
  //       show: false
  //     },
  //     zoom: {
  //       enabled: false
  //     },
  //     events: {
  //       mounted: function (chartContext, config) {
  //         const totalAnnotation = {
  //           x: 0,
  //           y: 0,
  //           marker: {
  //             size: 0
  //           },
  //           label: {
  //             borderColor: '#4e73df',
  //             offsetY: 0,
  //             style: {
  //               color: '#fff',
  //               background: '#4e73df',
  //               fontSize: '14px',
  //               fontWeight: 'bold'
  //             },
  //             text: `Total: ${total}`,
  //             padding: {
  //               top: 5,
  //               bottom: 5,
  //               left: 10,
  //               right: 10
  //             },
  //             borderRadius: 4
  //           }
  //         };

  //         // chartContext.updateOptions({
  //         //   annotations: {
  //         //     points: [totalAnnotation]
  //         //   }
  //         // });
  //       }
  //     }
  //   },

  //   title: {
  //     text: title,
  //     align: 'left',
  //     style: {
  //       fontSize: '16px',
  //       fontWeight: 'bold',
  //       color: '#333'
  //     }
  //   },
  // });



  const chartOptions = (title, total, categories = []) => ({
    chart: {
      type: "bar",
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      },
      events: {
        mounted: function (chartContext, config) {
          const totalAnnotation = {
            x: 0,
            y: 0,
            marker: {
              size: 0
            },
            label: {
              borderColor: '#4e73df',
              offsetY: 0,
              style: {
                color: '#fff',
                background: '#4e73df',
                fontSize: '14px',
                fontWeight: 'bold'
              },
              text: `Total: ${total}`,
              padding: {
                top: 5,
                bottom: 5,
                left: 10,
                right: 10
              },
              borderRadius: 4
            }
          };
        }
      }
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          colors: '#666',
          fontSize: '12px'
        }
      }
    },
    title: {
      text: title,
      align: 'left',
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#333'
      }
    },
  });

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  const currentData = selectedTab === 'today' ? todayData : totalData;


  return (
    <div className="main_container">
      <div className="right_col" role="main">
        <div className="container-box-top-header mb-2">
          <div className="container-box-top-header-left">
            <span><img src="img/chart.svg" alt="" /></span>
            <p>Statistics</p>
          </div>
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link dashboard-btn active"
                id="home-tab"
                data-bs-toggle="tab"
                type="button"
                role="tab"
                aria-selected={selectedTab === 'today' ? 'true' : 'false'}
                onClick={() => handleTabChange('today')}
              >
                Today
              </button >
            </li >

            <li className="nav-item" role="presentation" style={{ marginLeft: "10px" }}>
              <button
                className="nav-link dashboard-btn"
                id="profile-tab"
                data-bs-toggle="tab"
                type="button"
                role="tab"
                aria-selected={selectedTab === 'total' ? 'true' : 'false'}
                onClick={() => handleTabChange('total')}
              >
                Total
              </button>
            </li>
          </ul>
        </div>
        <div className="container-box">
          {selectedTab === 'total' && (
            <div className="container-box-inner table-reponsive-tabe margin-top-50">
              <div className="row">
                {[
                  { label: 'Booking', value: currentData?.data?.totalBooking, icon: <SlCalender />, link: '/order' },
                  { label: 'Pending Booking', value: currentData?.data?.totalPendingBookings, icon: <MdOutlinePendingActions />, link: '/partner-assign-order' },
                  { label: 'Completed Booking', value: currentData?.data?.totalCompleteBookings, icon: <MdIncompleteCircle />, link: '/completed-order' },
                  { label: 'Customer', value: currentData?.data?.totalUsers, icon: <FaUser />, link: '/users' },
                  // { label: 'Vendor', value: currentData?.data?.totalVender, icon: <FaUsers />, link: '/vendor' },
                  // { label: 'Active Vendor', value: currentData?.data?.totalActiveVender, icon: <FiUserCheck />, link: '/active-vendor' },
                  // { label: 'Inactive Vendor', value: currentData?.data?.totalInactiveVender, icon: <LuUserX />, link: '/inactive-vendor' },
                  { label: 'Earning', value: currentData?.data?.totalEarning, icon: <LuUserX /> },

                  // { label: 'Service Car', value: currentData?.data?.totalServiceCarBookings, icon: 'total-service-car.svg' },
                  // { label: 'Free Users', value: currentData?.data?.totalFreeUsers, icon: 'Free-user.svg' },
                  // { label: 'Paid Users', value: currentData?.data?.totalPaidUsers, icon: 'Paid-user.svg' },
                  // { label: 'Partner Assign', value: currentData?.data?.totalPaidUsers, icon: 'Paid-user.svg' },
                  // { label: 'Ongoing Order', value: currentData?.data?.totalOngoingBookings, icon: 'subscription.svg' },
                  // { label: 'Partner On The Way', value: currentData?.data?.totalPaidUsers, icon: 'Paid-user.svg' },
                  // { label: 'Services Started', value: currentData?.data?.totalPaidUsers, icon: 'Paid-user.svg' },



                ].map((item, index) => (
                  <div className="col-md-3" key={index}>
                    <div className={` position-relative g-box g-box${index + 1}`}>
                      <a href={item.link || "javascript:void(0)"} className="d-flex align-items-center">
                        <div className='image_dashboard'>
                          {item.icon}                          </div>
                        <div className='detailsdashboard'>

                          <p>{`${selectedTab === 'today' ? 'Today' : 'Total'} ${item.label}`}</p>
                          <div className="g-box-inner">
                            <h4>{item.value}</h4>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {selectedTab === 'today' && (
            <div className="container-box-inner table-reponsive-tabe margin-top-50">
              <div className="row">
                {[
                  { label: 'Booking', value: currentData?.data?.totalBookingsToday, icon: <SlCalender />, link: '/today-order' },
                  { label: 'Pending Booking', value: currentData?.data?.totalPendingBookingsToday, icon: <MdOutlinePendingActions />, link: '/today-pending-order' },
                  { label: 'Completed Booking', value: currentData?.data?.totalCompleteBookingsToday, icon: <MdIncompleteCircle />, link: '/today-complete-order' },
                  { label: 'Customer', value: currentData?.data?.totalUsersToday, icon: <FaUser />, link:'/today-user'},
                  // { label: 'Vendor', value: currentData?.data?.totalvendersToday, icon: <FaUsers /> },
                  // { label: 'Active Vendor', value: currentData?.data?.todayActiveVender, icon: <FiUserCheck />, link: '/active-vendor' },
                  // { label: 'Inactive Vendor', value: currentData?.data?.todayInactiveVender, icon: <LuUserX />, link: '/inactive-vendor' },
                  { label: 'Earning', value: currentData?.data?.todayearning, icon: <LuUserX /> },

                  // { label: 'Service Car', value: currentData?.data?.totalServiceCarBookingsToday, icon: 'total-service-car.svg' },
                  // { label: 'Free Users', value: currentData?.data?.totalFreeUsersToday, icon: 'Free-user.svg' },
                  // { label: 'Paid Users', value: currentData?.data?.totalPaidUsersToday, icon: 'Paid-user.svg' },
                  // { label: 'Partner Assign', value: currentData?.data?.totalPaidUsers, icon: 'Paid-user.svg' },
                  // { label: 'Ongoing Order', value: currentData?.data?.totalOngoingBookingsToday, icon: 'subscription.svg' },
                  // { label: 'Partner On The Way', value: currentData?.data?.totalPaidUsers, icon: 'Paid-user.svg' },
                  // { label: 'Services Started', value: currentData?.data?.totalPaidUsers, icon: 'Paid-user.svg' },
                ].map((item, index) => (
                  <div className="col-md-3" key={index}>
                    <div className={` position-relative g-box g-box${index + 1}`}>
                      <a href={item.link || "javascript:void(0)"} className="d-flex align-items-center">
                        <div className='image_dashboard'>
                          {/* <img src={`img/${item.icon}`} alt="" /> */}
                          {item.icon}
                        </div>
                        <div className='detailsdashboard'>
                          <p>{`${selectedTab === 'today' ? 'Today' : 'Total'} ${item.label}`}</p>
                          <div className="g-box-inner ">
                            <h4>{item.value}</h4>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Customer Chart */}

          <div className='row'>
            <div className="col-md-6">
              <div className='container-box chart-box'>
                <div className="chart-header d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className='mb-0'>Monthly Customers</h5>
                    <span className="time-range">
                      Jan - {moment().format('MMM')} {moment().format('YYYY')}
                    </span>
                  </div>
                  <div className="total-display d-flex gap-2">
                    <p className="total-badge totalbadgedesign fw-bold">TOTAL <span>{chartData.totals?.users || 0}</span></p>

                  </div>
                </div>

                <div className="chart-container">
                  <ReactApexChart
                    options={chartOptions("Customer Growth", chartData.totals?.users, chartData.categories)}
                    series={chartData.seriesUser}
                    type="bar"
                    height={300}
                  />
                </div>

              </div>
            </div>

            <div className="col-md-6">
              <div className='container-box chart-box'>
                <div className="chart-header  d-flex justify-content-between  align-items-center">
                  <div>
                    <h5 className='mb-0'>Monthly Bookings</h5>
                    <span className="time-range">
                      Jan - {moment().format('MMM')} {moment().format('YYYY')}
                    </span>
                  </div>
                  <div className="total-display d-flex gap-2">
                    <p className="total-badge totalbadgedesign fw-bold">TOTAL <span>{chartData.totals?.bookings || 0}</span></p>

                  </div>
                </div>

                <div className="chart-container">
                  <ReactApexChart
                    options={chartOptions("Booking Trends", chartData.totals?.bookings, chartData.categories)}
                    series={chartData.seriesBooking}
                    type="bar"
                    height={300}
                  />
                </div>

              </div>
            </div>

            <div className="col-md-12">
              <div className='container-box chart-box'>
                <div className="chart-header d-flex justify-content-between align-items-center">
                  <h5 className='mb-0'>Daily Bookings Comparison</h5>
                  <span className="time-range">
                    {moment().format('MMMM YYYY')} vs {moment().subtract(1, 'month').format('MMMM YYYY')}
                  </span>
                </div>
                <div className="chart-container">
                  <ReactApexChart
                    options={chartOptions("Daily Bookings Comparison", chartData.totals?.bookings, chartData.categoriesBookingDaily)}
                    series={chartData.seriesBookingDaily}
                    type="bar"
                    height={350}
                  />
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}

export default Dashboard;
